import React from "react";

type PropsType = {
  children: React.ReactNode;
};

export default function Container({ children }: PropsType) {
  return (
    <div data-testid="provider_search" className="mx-auto bg-gray-100">
      {children}
    </div>
  );
}
